<template>
    <div>
        <v-icon x-small color="green">mdi-circle</v-icon>
        <v-icon x-small color="green">mdi-circle</v-icon>
        <v-icon x-small color="green">mdi-circle</v-icon>
    </div>
</template>

<script>
export default {
name: "IconQuantityHi"
}
</script>

<style scoped>

</style>
